import type { ILocationRepository } from '../repositories/ILocationRepository.js';

interface Deps { locationRepository: ILocationRepository; }

export function createDeleteLocationUseCase({ locationRepository }: Deps) {
  return async function deleteLocation(id: string): Promise<void> {
    return locationRepository.delete(id);
  };
}
